<div class="main-response-container">
	<div class="main-response-block">
		<div class="main-response-logo">
			<img src="/assets/images/co-pilot.svg" alt="co-pilot logo" />
		</div>
		<div progressiveTyping class="main-response-text" [text]="getResponseText() | markdown"></div>
		<div>
			<button *ngIf="getResponseText().length > 0 && !isLoading" matTooltip="Copy" (click)="copyResponseToClipboard()" matTooltipPosition="right" class="hover-over-button">
				<i class="fa-solid fa-copy"></i>
			</button>
		</div>
	</div>
</div>